import React from 'react';
import SalesLibrary from '../components/Library';
import { withLmsStore } from '../utils/lmsStore';

const LMSSalesLibraryContainer = (props) => {
  return <SalesLibrary {...props} />;
};

export default withLmsStore(LMSSalesLibraryContainer);
